import {
  createGlobalStyle,
} from 'styled-components';

import GTHaptikRegularWoff from '../assets/fonts/GT-Haptik-Regular.woff';
import GTHaptikRegularWoff2 from '../assets/fonts/GT-Haptik-Regular.woff2';
import GTHaptikRegularTtf from '../assets/fonts/GT-Haptik-Regular.ttf';

import GTHaptikMediumWoff from '../assets/fonts/GT-Haptik-Medium.woff';
import GTHaptikMediumWoff2 from '../assets/fonts/GT-Haptik-Medium.woff2';
import GTHaptikMediumTtf from '../assets/fonts/GT-Haptik-Medium.ttf';

import GTHaptikBoldWoff from '../assets/fonts/GT-Haptik-Bold.woff';
import GTHaptikBoldWoff2 from '../assets/fonts/GT-Haptik-Bold.woff2';
import GTHaptikBoldTtf from '../assets/fonts/GT-Haptik-Bold.ttf';

import CartographMonoCFDemiBold from '../assets/fonts/CartographMonoCF-DemiBold.otf';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'GT Haptik';
    src: local('GT Haptik'),
      url(${GTHaptikRegularWoff}) format("woff"),
      url(${GTHaptikRegularWoff2}) format("woff2"),
      url(${GTHaptikRegularTtf}) format("truetype");
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'GT Haptik';
    src: local('GT Haptik'),
      url(${GTHaptikMediumWoff}) format("woff"),
      url(${GTHaptikMediumWoff2}) format("woff2"),
      url(${GTHaptikMediumTtf}) format("truetype");
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'GT Haptik';
    src: local('GT Haptik'),
      url(${GTHaptikBoldWoff}) format("woff"),
      url(${GTHaptikBoldWoff2}) format("woff2"),
      url(${GTHaptikBoldTtf}) format("truetype");
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'CartographMonoCF';
    src: local('CartographMonoCF'), url(${CartographMonoCFDemiBold});
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    background-color: #F8F9FB;
    -webkit-font-smoothing : antialiased;
  }
`;

export default GlobalStyle;
